import CustomFilterSelect from "./CustomFilterSelect";

const FilterAmount = (props: any) => {
  const AmountFilterData = [
    { id: "1", name: "<$20" },
    { id: "2", name: "$20-$50" },
    { id: "3", name: "$50-$100" },
    { id: "4", name: "$100-$200" },
    { id: "5", name: "$200-$500" },
    { id: "6", name: "$500-$1000" },
    { id: "7", name: ">$1000" },
  ];
  return (
    <CustomFilterSelect
      source="amount"
      label="Amount"
      choices={AmountFilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterAmount;
